import * as React from 'react'
import { MessageFileListConnected } from './MessageFileListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MessageFileListExamples = () => {
  return (
    <div className="MessageFileListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MessageFileListConnected messageId="123" />
      </Provider>
    </div>
  )
}
